import React from 'react';
import Layout from '../../Components/Layout';
import { Box, Typography, Paper } from '@mui/material';

function KnowledgeBaseOverview() {
  return (
    <Layout>
      <Box sx={{ mt: 3, px: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
              Knowledge base
            </Typography>
            <Typography variant="body2" sx={{ color: '#6b7280' }}>
              Manage documents, URLs, and content for your agents
            </Typography>
          </Box>
        </Box>

        <Paper sx={{ p: 3 }}>
          <Typography variant="body2" sx={{ color: '#6b7280' }}>
            This is a placeholder page. Build your Knowledge base overview here.
          </Typography>
        </Paper>
      </Box>
    </Layout>
  );
}

export default KnowledgeBaseOverview;


